const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLaptop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M28 21.332V8.53203C28 7.41193 28 6.85187 27.782 6.42405C27.5903 6.04773 27.2843 5.74176 26.908 5.55002C26.4802 5.33203 25.9201 5.33203 24.8 5.33203H7.2C6.0799 5.33203 5.51984 5.33203 5.09202 5.55002C4.71569 5.74176 4.40973 6.04773 4.21799 6.42405C4 6.85187 4 7.41193 4 8.53203V21.332",
    stroke: "#CCCCCC",
    style: {
      stroke: "#CCCCCC",
      stroke: "color(display-p3 0.8008 0.8008 0.8008)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 21.332H29.3333V23.4654C29.3333 24.5855 29.3333 25.1455 29.1153 25.5733C28.9236 25.9497 28.6176 26.2556 28.2413 26.4474C27.8135 26.6654 27.2534 26.6654 26.1333 26.6654H5.86662C4.74652 26.6654 4.18647 26.6654 3.75864 26.4474C3.38232 26.2556 3.07636 25.9497 2.88461 25.5733C2.66663 25.1455 2.66663 24.5855 2.66663 23.4654V21.332Z",
    stroke: "#CCCCCC",
    style: {
      stroke: "#CCCCCC",
      stroke: "color(display-p3 0.8008 0.8008 0.8008)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaptop);
export default __webpack_public_path__ + "static/media/icon_laptop.d6f1f99627a8a5989a09ae5961733783.svg";
export { ForwardRef as ReactComponent };